import React, { useEffect, useState } from "react";
import { DotLoader, Logo } from "@olivahealth/oli-ui";
import { useSigninCheck } from "@olivahealth/firebase/client";
import logger from "@olivahealth/logger/client";
import useTranslation from "../../../../hooks/useTranslation";
import { useAuthAuthorized } from "../../../../services/contexts/AuthAuthorizedContext";
import { useAmplitude } from "../../../../services/contexts/AmplitudeContext";
import ErrorPage from "../../../pages/Error";
import { useSignOut } from "../../../../services/contexts/SignOutContext";
import AuthPanel from "../AuthPanel";
import * as s from "./styles";

export type AuthMode = "signup" | "login";

export default function AuthPage() {
  const { t } = useTranslation("auth", { keyPrefix: "authPage" });
  const { status, setStatus } = useAuthAuthorized();
  const { status: signInStatus, data } = useSigninCheck();
  const [authMode] = useState<AuthMode>("login");
  const { signOut } = useSignOut();
  const { trackEvent } = useAmplitude();

  useEffect(() => {
    trackEvent("Landing page opened");
  }, [trackEvent]);

  if (signInStatus === "error" || status === "error") {
    logger.error("[AuthPage]", "Error on user logging in", {
      signInStatus,
      status,
      data,
    });
    return (
      <ErrorPage
        title={t("error.title")}
        description=""
        buttonLabel={t("error.buttonLabel")}
        onClickButton={() => {
          setStatus("success");
          signOut("Auth page error button click");
        }}
      />
    );
  }

  const initialRender =
    status === "success" && typeof data?.signedIn === "undefined";

  if (signInStatus === "loading" || status === "loading" || initialRender) {
    return (
      <div className="flex h-full w-full">
        <div className="m-auto flex">
          <DotLoader />
        </div>
      </div>
    );
  }

  return (
    <div className={s.authPageContainer}>
      <div className="absolute top-8 left-8">
        <Logo color="white" height={28} variant="full" />
      </div>
      <div data-dd-privacy="mask-user-input" className="mx-auto max-w-xl">
        <div className="flex flex-col items-center">
          <AuthPanel authMode={authMode} />
        </div>
      </div>
    </div>
  );
}
